import React, { useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";

export const HeaderTitle = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => {
  const titleRef = useRef<HTMLElement>(null);

  return (
    <div className="me-4 mb-2_5">
      <h1 className="h5 mb-1">
        <span
          ref={titleRef}
          className="d-block"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </span>

        {!!title && (
          <UncontrolledTooltip
            placement="top"
            target={titleRef as React.RefObject<HTMLElement>}
          >
            {title}
          </UncontrolledTooltip>
        )}
      </h1>

      <h4 className="mb-0 text-nowrap">{subtitle}</h4>
    </div>
  );
};
